import React, { useContext, useMemo } from 'react'
import { StoresContext } from '@App/contexts/index'
import { useNavigate } from 'react-router'
import { calcNumPages } from '@App/helpers/pagination/calc-num-pages/index'
import Table, { type TableRowData } from '@Components/ViewWork/Table/index'
import { buildTableRows, type EnrichedSuggestion } from '@Scenes/RightsholderScene/ChangeRequests/build-table-rows'
import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock/index'
import { getNumTitles } from '@App/helpers/pagination/get-num-titles/index'
import PaginationAndLimit from '@Components/Navigations/PaginationAndLimit/index'
import type { PaginationBody } from '@Entities/pagination'

interface ChangeRequestTableProps {
    items: EnrichedSuggestion[]
    totalResults: number
    currentPage: number
    limit: number
    onPageChange: (pagination: PaginationBody) => void
    onDismiss?: (suggestionId: number) => void
}

const ChangeRequestTable = ({
    items,
    totalResults,
    currentPage,
    limit,
    onPageChange,
    onDismiss,
}: ChangeRequestTableProps) => {
    const { rightsholderStore } = useContext(StoresContext)
    const navigate = useNavigate()
    const paginationInfo = calcNumPages(totalResults, limit, currentPage)

    const tableRows: TableRowData[] = useMemo(
        () => buildTableRows(items, rightsholderStore.currentRightsholderId, navigate, onDismiss),
        [items, rightsholderStore.currentRightsholderId, navigate, onDismiss]
    )

    return (
        <>
            <PaginationResultsBlock
                totalResults={totalResults}
                hideNoResults
                workNumTitles={getNumTitles(totalResults, currentPage, limit)}
                resultsMessage="Change Requests Found"
                showCompactToggle={false}
            />
            <Table rows={tableRows} />
            <PaginationAndLimit
                count={totalResults}
                limit={limit}
                paginationInfo={paginationInfo}
                onPageChange={onPageChange}
            />
        </>
    )
}

export default ChangeRequestTable
